export const RoleModule = {
    namespaced: true,
    state: {
        loadRoleData: 1,
        RoleList: [],
        RoleFilterList: []
    }
}